import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { ImageResizeMode, ImageResizeAnchorPosition } from './Enums'
/**
* Class ResourcesGetFileRequestQuery
*  Query params for operation "ResourcesGetFile"
*/
export class ResourcesGetFileRequestQuery extends ActiveModel {

  /**
  * Width
  * Желаемая ширина изображения. <para /><br>Если не указана, то вычисляется от указанного значения Infrastructure.Images.ImageResizeOptions.Height с сохранением<br>пропорций за счёт информации из оригинального изображения<br>  */
  @ActiveField()
  Width?: number


  /**
  * Height
  * Желаемая высота изображения. <para /><br>Если не указана, то вычисляется от указанного значения Infrastructure.Images.ImageResizeOptions.Width с сохранением<br>пропорций за счёт информации из оригинального изображения<br>  */
  @ActiveField()
  Height?: number


  /**
  * Mode
  * Режим изменения размера. Если не указан, то по умолчанию Infrastructure.Images.ImageResizeMode.Max  */
  @ActiveField()
  Mode?: ImageResizeMode


  /**
  * Position
  * Если не указан, то по умолчанию Infrastructure.Images.ImageResizeAnchorPosition.Center  */
  @ActiveField()
  Position?: ImageResizeAnchorPosition
}
